import type { FC } from "react";
import { Image } from "react-bootstrap";

interface Props {
  level: number;
  className?: string;
}

// Mapování levelů na texty a ikony
const LEVEL_CONFIG = {
  0: {
    title: "Full team dead. RIP",
    description: "Loni to nedal vůbec nikdo. Totální výmaz.",
    icon: "level-0.png",
    bg: "bg-level-0.png",
  },
  1: {
    title: "Total cringe lvl 1000",
    description: "Loni to na dal jen 1 z 10. Insane.",
    icon: "level-1.png",
    bg: "bg-level-1.png",
  },
  2: {
    title: "Pain mode",
    description: "Loni to dalo jen pár vyvolených. 2 z 10. Fakt těžký",
    icon: "level-2.png",
    bg: "bg-level-2.png",
  },
  3: {
    title: "Příklad level Boss",
    description: "Loni to dali jen 3 z 10.",
    icon: "level-3.png",
    bg: "bg-level-3.png",
  },

  4: {
    title: "Dřina edition",
    description: "Loni to dali jen 4 z 10. Těžký, ale dá se vydřít.",
    icon: "level-4.png",
    bg: "bg-level-4.png",
  },
  5: {
    title: "Fifty-fifty",
    description: "50 %. Půlka třídy brečí, půlka slaví.",
    icon: "level-5.png",
    bg: "bg-level-5.png",
  },
  6: {
    title: "To dáš… asi",
    description: "Úspěšnost loni 6 z 10. Nebyl to hell, ale ani chill.",
    icon: "level-6.png",
    bg: "bg-level-6.png",
  },

  7: {
    title: "Tři čtvrtě na chill",
    description: "7 z 10 to loni dalo. To taky dáš.",
    icon: "level-7.png",
    bg: "bg-level-7.png",
  },
  8: {
    title: "Pohoda speedrun",
    description: "Loni to dalo 8 z 10. Pohodička.",
    icon: "level-8.png",
    bg: "bg-level-8.png",
  },
  9: {
    title: "Warm-up",
    description: "Loni to dalo 9 z 10. Jednoduchý, na zahřátí.",
    icon: "level-9.png",
    bg: "bg-level-9.png",
  },
  10: {
    title: "Skill check za nula",
    description: "Loni to zvládli všichni. Easy win.",
    icon: "level-10.png",
    bg: "bg-level-10.png",
  },
};

export const LastYearResultsBanner: FC<Props> = ({ level, className }) => {
  const config = LEVEL_CONFIG[level as keyof typeof LEVEL_CONFIG] || LEVEL_CONFIG[1];

  return (
    <div
      className={`last-year-results-banner ${className ?? ""}`}
      style={{ backgroundImage: `url(/images/last-results/${config.bg})` }}
    >
      <div className="last-year-results-banner__icon">
        <Image src={`/images/last-results/${config.icon}`} alt={config.title} loading="eager" />
      </div>
      <div className="last-year-results-banner__content">
        <span className="last-year-results-banner__title">{config.title}</span>
        <span className="last-year-results-banner__description">{config.description}</span>
      </div>
    </div>
  );
};
